import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

import CatPic from '../assets/images/cat.webp';

export default function WalkingCat() {
  // pos: 0-93 in vw units; dir: 1=right, -1=left
  const [pos, setPos] = useState(20);
  const [dir, setDir] = useState(1);
  const [isWalking, setIsWalking] = useState(true);

  const state = useRef({ pos: 20, dir: 1, isWalking: true });

  useEffect(() => {
    let cancelled = false;

    // Move the cat 5vw/s at 50ms ticks
    const moveInterval = setInterval(() => {
      if (cancelled || !state.current.isWalking) return;

      state.current.pos += state.current.dir * 0.25;

      // Bounce off edges
      if (state.current.pos >= 93) {
        state.current.pos = 93;
        state.current.dir = -1;
        setDir(-1);
      } else if (state.current.pos <= 1) {
        state.current.pos = 1;
        state.current.dir = 1;
        setDir(1);
      }

      setPos(state.current.pos);
    }, 50);

    // Behaviour: walk → stop → turn → walk → ...
    const schedule = () => {
      if (cancelled) return;

      const walkMs = (4 + Math.random() * 6) * 1000; // walk 4-10 s
      const stopMs = (1.2 + Math.random() * 2.8) * 1000; // rest 1.2-4 s

      state.current.isWalking = true;
      setIsWalking(true);

      setTimeout(() => {
        if (cancelled) return;
        state.current.isWalking = false;
        setIsWalking(false);

        setTimeout(() => {
          if (cancelled) return;
          // Always turn around after resting
          state.current.dir = -state.current.dir;
          setDir(state.current.dir);
          schedule();
        }, stopMs);
      }, walkMs);
    };

    schedule();

    return () => {
      cancelled = true;
      clearInterval(moveInterval);
    };
  }, []);

  return (
    <div
      className="fixed bottom-0 z-[9999] pointer-events-none select-none"
      style={{
        left: `${pos}vw`,
        transform: `scaleX(${dir})`,
        transition: 'transform 0.3s ease',
      }}
    >
      <motion.span
        animate={isWalking ? { y: [0, -5, 0] } : { y: 0 }}
        transition={
          isWalking
            ? { duration: 0.4, repeat: Infinity, ease: 'easeInOut' }
            : { duration: 0.2 }
        }
        className="inline-block"
      >
        <img className="w-8 h-8" src={CatPic} />
      </motion.span>
    </div>
  );
}
